import React, { useState } from "react";
import Generate_Externally_Service_modal from "../generate_Externally_Service_modal/Generate_Externally_Service_modal";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Externally_Service_table() {
  const [showModal, setModal] = useState(false);
 

  /* ================= TABLE DATA ================= */
  const data = [
    {
      srNo: 101,
      documentName: "Document Name 1",
      attachedFile: "Externally Provided Product & Service1001.PDF",
      remarks: "---",
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  
  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Document Name</th>
                  <th>
                   Attached File
                  </th>
                  <th>
                   Remarks
                  </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.srNo}</td>

                    {/* Document Name */}
                    <td>{row.documentName}</td>

                    {/* Attached File */}
                    <td>{row.attachedFile}</td>

                    {/* Remarks */}
                    <td>{row.remarks}</td>

                    {/* Action Icons */}
                    <td>
                      <div className="action_icons">
                        <p className="blue_link_text" onClick={() => setModal(true)}>

                       Generate
                        </p>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
         <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>

      
      <Generate_Externally_Service_modal
        show={showModal}
        onHide={() => setModal(false)}
        modalHeadingText={"Externally Provided Product & Service"}
      />

    </>
  );
}

export default Externally_Service_table;
